import React from 'react'
import Slick from 'react-slick'
import './styles/slick.css'
import './styles/Slider.css'
import Hammer from 'rc-hammerjs'
import { scroller, Element } from 'react-scroll'
import {CSSTransition} from 'react-transition-group'

class Slider extends React.Component{

	constructor(props) {
		super(props);

		this.state={
			slideIndex: 0,
			thumbnails: false,
		}

		this.handleSwipe = this.handleSwipe.bind(this)
		this.slickNext = this.slickNext.bind(this)
		this.slickPrev = this.slickPrev.bind(this)
		this.slickGoToSlide = this.slickGoToSlide.bind(this)
		this.slickAfterChange = this.slickAfterChange.bind(this)

		this.thumbnailToggle = this.thumbnailToggle.bind(this)
		this.renderThumbnails = this.renderThumbnails.bind(this)
	}

	render(){
		const { thumbnails } = this.state
		const { images, innerHeight, media} = this.props
		const settings = {
			infinite: false,
			// fade: true,
			speed: 500,
			useCSS:false,
			arrows: false,
			accessibility: false,
			draggable:false,
			swipe:false,
			afterChange: this.slickAfterChange,
			lazyLoad: 'progressive',
		}

		const styles={
			Slider:{
				height: innerHeight,
			},
		}

		return (
		<Hammer onSwipe={(e)=>this.handleSwipe(e)}>
			<div>
				<Element name="slideshow">
				<div className="Slider" style={styles.Slider} >
					<Slick {...settings} ref={c => this.slider = c } >
						{images.map((b)=>(
							<div key={b.title} className="Slide">
								<div className="SlideInner">
									<img className="SlideImg padding-horizontal" src={b.desktopURL} alt={b.title} />
								</div>
							</div>
						))}
					</Slick>
					<div className="SlickButton SlickNextButton clickable" onClick={this.slickNext}></div>
					<div className="SlickButton SlickPrevButton clickable" onClick={this.slickPrev}></div>
				</div>
				</Element>
				{media!=='MOBILE'?
				<div className="SliderControls padding-vertical">
					<div className="row">
					    <div className="col col-6">
							<i className="icon icon-fw icon-Prev clickable" onClick={this.slickPrev} />
							<i className="icon icon-fw icon-Thumbnails clickable" onClick={()=>{this.thumbnailToggle();this.scrollToSlideshow()}} />
							<i className="icon icon-fw icon-Next clickable" onClick={this.slickNext} /> 
							<small className="grey-type small-type">{this.state.slideIndex + 1 } / {images.length}</small>
					    </div>
					    <div className="col col-6 mobile-align-right">
					        <span className="clickable" onClick={this.scrollToDescription}>
					                <i className="icon icon-fw icon-Info clickable" />
					        </span>
					    </div>
					</div>
				</div>
				:
				<div className="SliderControls padding align-center">

							<i className="icon icon-fw icon-Prev clickable" onClick={this.slickPrev} />
							<i className="icon icon-fw icon-Thumbnails clickable" onClick={()=>{this.thumbnailToggle();this.scrollToSlideshow()}} />
							<i className="icon icon-fw icon-Next clickable" onClick={this.slickNext} />

					        <span className="clickable" onClick={this.scrollToDescription}>
					                <i className="icon icon-fw icon-Info clickable" />
					        </span>

				</div>
				}
			<CSSTransition
				in={thumbnails}
                timeout={600}
                classNames="long-fade"
                mountOnEnter={true}
                unmountOnExit={true}
                >
				{  this.renderThumbnails() }
			</CSSTransition>
			</div>

		</Hammer>
		)
	}

	renderThumbnails(){
		const {images} = this.props
		const thumbCount = images.length
		/*----------  Calculate Thumbnail Style  ----------*/
		let col,
			row,
			toggle;
		if(window.innerWidth <= window.innerHeight){

			col = 2
			row = 3
			toggle = true

		}else{
			col = 3
			row = 2
			toggle = false
		}

		while(col*row < thumbCount){
			if(toggle){
				col += 1
			}else{
				row += 1
			}
			toggle = !toggle
		}

		const thumbStyle = {
			height: 100/row + '%',
			width: 100/ col + '%',
		}
		return(
			<div className="Thumbnails">
				{images.map((b, i)=>(
					<div key={b.title} className="Thumbnail" style={thumbStyle} >
						<img 
							src={b.mobileURL} 
							alt={b.title} 
							className="clickable" 
							onClick={ () => { 
								this.thumbnailToggle(); 
								this.slickGoToSlide(i); 
							}}
						/>
					</div>
				))}
			</div>
		)
	}


	handleSwipe(e) {
		if(e.offsetDirection===2){
			this.slickNext()
		}
		if(e.offsetDirection===4){
			this.slickPrev()
		}
	}

	slickNext() {
		this.slider.slickNext()
		this.scrollToSlideshow()

		if(this.state.thumbnails){
			this.setState({ thumbnails: false })
		}
	}

	slickPrev() {
		this.slider.slickPrev()
		this.scrollToSlideshow()
		if(this.state.thumbnails){
			this.setState({ thumbnails: false })
		}
	}

	slickAfterChange(i) {
		this.setState({
			slideIndex: i,
		})
	}

	slickGoToSlide(i) {
		this.slider.slickGoTo(i)
	}

	scrollToSlideshow(){
		scroller.scrollTo('slideshow', {
			duration: 500,
			smooth: true,
		})
	}

	scrollToDescription(){
		scroller.scrollTo('description', {
			duration: 500,
			smooth: true,
		})
	}

	thumbnailToggle(){
		this.setState({
			thumbnails: !this.state.thumbnails,
		})
	}

}


export default Slider


// WEBPACK FOOTER //
// ./src/Slider.js